import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-meter',
  templateUrl: './meter.component.html',
  styleUrls: ['./meter.component.scss']
})
export class MeterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
